import { managerV1BaseUrl } from '@/utils';
import { useEffect } from 'react';

export const NavigateToV1 = () => {
  useEffect(() => {
    window.location.replace(managerV1BaseUrl);
  }, []);
  return <></>;
};
